var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7a5 5 0 100 10 5 5 0 000-10zm-3 5a3 3 0 116 0 3 3 0 01-6 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C9.106 3 6.63 4.281 4.715 5.787 2.8 7.295 1.373 9.084.556 10.24l-.002.004a3.064 3.064 0 000 3.512l.002.004c.817 1.156 2.243 2.945 4.16 4.453C6.63 19.719 9.105 21 12 21s5.37-1.281 7.285-2.787c1.916-1.508 3.342-3.297 4.159-4.453l.003-.004a3.064 3.064 0 000-3.512l-.003-.004c-.817-1.156-2.242-2.945-4.16-4.453C17.37 4.281 14.895 3 12 3zM2 12c0-.217.067-.43.191-.608.757-1.07 2.054-2.69 3.76-4.033C7.663 6.014 9.714 5 12 5c2.287 0 4.338 1.014 6.048 2.36 1.708 1.342 3.004 2.961 3.76 4.032a1.064 1.064 0 010 1.216c-.756 1.07-2.053 2.69-3.76 4.033C16.338 17.986 14.288 19 12 19c-2.287 0-4.338-1.014-6.048-2.36-1.707-1.342-3.004-2.961-3.76-4.032A1.064 1.064 0 012 12z"
  })));
}
export default SvgView;